import React from "react";
import { Property } from "./Property";

import s from "../../ProductConfiguratorComponent.module.scss";

export const InputList = ({
  list = [],
  isValueEditable = false,
  onChange,
  headerStyles,
  propertyStyles,
}) =>
  list?.map((part, index) => (
    <div key={index} className={s.cardInputSection}>
      <h5 className={headerStyles}>{part.presentation}</h5>
      {part?.properties?.map((property, ind) => (
        <Property
          key={ind}
          property={property}
          isValueEditable={isValueEditable}
          onChange={onChange}
          propertyStyles={propertyStyles}
        />
      ))}
    </div>
  ));
